import React, { useEffect, useState } from "react";
import { useSidebarStatus } from "../../../context/SideBarStatusContext";
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from "@headlessui/react";
import { sidebarData, defaultSiderBar } from "./sidebarData";
import { startCase } from "lodash";
import { Link } from "react-router-dom";
import { ChevronRightIcon, ChevronDownIcon } from "@heroicons/react/20/solid";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import "./tooltip.css";

const AdminSideBar = () => {
  const [isSubmenuOpen, setSubmenuOpen] = useState(false);
  const { isSidebarOpen, setSidebarOpen } = useSidebarStatus();
  const [mainSideBar, setMainSideBar] = useState([]);
  const [openPanel, setOpenPanel] = useState(null);
  const location = useLocation();
  const { currentUser, authenticated } = useAuth();
  const pathname = location.pathname;

  const togglePanel = (panelIndex) => {
    setOpenPanel(openPanel === panelIndex ? null : panelIndex);
  };

  useEffect(() => {
    if (currentUser?.roleId == 2) {
      defaultSiderBar?.splice(1, 1);
      setMainSideBar(defaultSiderBar);
    } else {
      setMainSideBar(defaultSiderBar);
    }
  }, []);

  return (
    <div className="flex   w-max sidebar_mainbox">
      <aside
        className={` ${
          isSidebarOpen ? "w-64" : "w-16"
        } transition-all duration-300 `}
      >
        {
          // currentUser?.roleId == 1
          //   ? defaultSiderBar.splice(1, 1).map((v, i) => {
          //       return (
          //         <div key={v.id} className="px-2  text-sm">
          //           <Link
          //             to={v.path}
          //             className={`px-2 py-2 font-semibold siderbar-menus   w-full block text-base  ${
          //               pathname == v.path ? "sidebar-active" : ""
          //             } rounded-md  `}
          //           >
          //             <p className="flex items-center">
          //               <span>{v.icon}</span>{" "}
          //               <span
          //                 style={
          //                   !isSidebarOpen
          //                     ? { display: "none" }
          //                     : { display: "block" }
          //                 }
          //               >
          //                 {" "}
          //                 {v.title}
          //               </span>{" "}
          //             </p>
          //           </Link>
          //         </div>
          //       );
          //     }):
          mainSideBar.map((v, i) => {
            return (
              <div key={v.id} className="px-2  text-sm relative">
                <Link
                  to={v.path}
                  className={`px-2 py-2 font-semibold siderbar-menus   w-full block text-base  ${
                    pathname == v.path || pathname.includes(v.path)
                      ? "sidebar-active"
                      : ""
                  } rounded-md ${!isSidebarOpen ? "justify-center" : ""}   `}
                >
                  <p className="flex items-center ">
                    <span>{v.icon}</span>{" "}
                    <span
                      style={
                        !isSidebarOpen
                          ? { display: "none" }
                          : { display: "block" }
                      }
                    >
                      {" "}
                      {v.title}
                    </span>
                    {/* <span
                      className={` ${
                        !isSidebarOpen ? "tooltip" : "hidden"
                      }`}
                    >
                      {v.title}
                    </span> */}
                  </p>
                </Link>
              </div>
            );
          })
        }
        <div className="mt-2">
          {sidebarData.map((value, index) => {
            return (
              <Disclosure
                key={index}
                as="div"
                className=" border-gray-200 px-2"
                open={openPanel == index}
              >
                <h3 className="-my-2 flow-root text-base">
                  <Link to={value.path}>
                    <DisclosureButton
                      className={`group flex w-full items-center justify-between siderbar-menus    px-2 py-2 text-gray-400 hover:text-gray-500 mb-3  

                   rounded-md ${!isSidebarOpen ? "justify-center" : ""}  `}
                      onClick={() => togglePanel(index)}
                    >
                      <p className="flex items-center submenu-head ">
                        <span>{value.icon} </span>
                        <span
                          style={
                            !isSidebarOpen
                              ? { display: "none" }
                              : { display: "block" }
                          }
                          className="font-semibold    text-base "
                        >
                          {startCase(value.title)}
                        </span>
                      </p>

                      <span
                        style={
                          !isSidebarOpen
                            ? { display: "none" }
                            : { display: "block" }
                        }
                        className="ml-6 flex items-center"
                      >
                        <ChevronRightIcon
                          aria-hidden="true"
                          className="h-5 w-5 group-data-[open]:hidden"
                        />
                        <ChevronDownIcon
                          aria-hidden="true"
                          className="h-5 w-5 [.group:not([data-open])_&]:hidden"
                        />
                      </span>
                    </DisclosureButton>
                  </Link>

                  <DisclosurePanel>
                    <div className="px-1 py-1 -mt-1  ">
                      {value.subTitle.map((v, i) => {
                        return (
                          <div key={i}>
                            <Link
                              to={v.path}
                              className={`block  text-s px-2 py-2 font-semibold  rounded-md  siderbar-menus  ${
                                pathname == `/admin/${v.path}` ||
                                pathname.includes(`/admin/${v.path}`)
                                  ? "sidebar-active"
                                  : ""
                              }
                          `}
                            >
                              <span>{v.icon} </span>
                              <span
                                style={
                                  !isSidebarOpen
                                    ? { display: "none" }
                                    : { display: "block" }
                                }
                                className="font-semibold submenu-head   text-base "
                              >
                                {startCase(v.title)}
                              </span>
                            </Link>
                          </div>
                        );
                      })}
                    </div>
                  </DisclosurePanel>
                </h3>
              </Disclosure>
            );
          })}
        </div>
      </aside>
    </div>
  );
};

export default AdminSideBar;
